var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73681 4.18286C4.64733 4.18286 2.14282 6.68737 2.14282 9.77685C2.14282 12.8735 3.38138 14.4235 8.56559 18.4556L10.9475 20.3082C11.5665 20.7897 12.4334 20.7897 13.0524 20.3082L15.4343 18.4556C20.6186 14.4235 21.8571 12.8735 21.8571 9.77685C21.8571 6.68737 19.3526 4.18286 16.2631 4.18286C14.659 4.18286 13.2308 4.91175 12 6.31419C10.7692 4.91175 9.34096 4.18286 7.73681 4.18286Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFilled);
export default __webpack_public_path__ + "static/media/like_filled.8ab47f301805955098e5a10cee12502e.svg";
export { ForwardRef as ReactComponent };